import Vue from "vue";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import JsonExcel from "vue-json-excel";
import vueSelect2 from "vue-select2";

const requireComponent = require.context("@/components", true, /\.vue$/);

requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName);

    const componentName =
        componentConfig.default.name ||
        upperFirst(
            camelCase(fileName.replace(/^\.\//, "").replace(/\.\w+$/, ""))
        );

    Vue.component(componentName, componentConfig.default || componentConfig);
});

Vue.component("downloadExcel", JsonExcel);
//Vue.component("vue-select2", vueSelect2);
